"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncAnalyticsAndTrackingContainer = AsyncAnalyticsAndTrackingContainer;
exports.AsyncTrackingPage = AsyncTrackingPage;
exports.AsyncDomainsAndIPPage = AsyncDomainsAndIPPage;
exports.AsyncAnalyticsViewsPage = AsyncAnalyticsViewsPage;
exports.AsyncCookiePolicyPage = AsyncCookiePolicyPage;
exports.AsyncCustomJSPage = AsyncCustomJSPage;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var AnalyticsAndTrackingContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/AnalyticsAndTrackingContainer'
    /* webpackChunkName: "chunk-analytics-and-tracking" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncAnalyticsAndTrackingContainer(props) {
  return _react.default.createElement(AnalyticsAndTrackingContainer, props);
}

var TrackingPage = (0, _Loadable.default)({
  loader: function loader() {
    return import('./components/TrackingPage'
    /* webpackChunkName: "chunk-analytics-and-tracking" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncTrackingPage(props) {
  return _react.default.createElement(TrackingPage, props);
}

var DomainsAndIPPage = (0, _Loadable.default)({
  loader: function loader() {
    return import('./components/DomainsAndIPPage'
    /* webpackChunkName: "chunk-analytics-and-tracking" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncDomainsAndIPPage(props) {
  return _react.default.createElement(DomainsAndIPPage, props);
}

var AnalyticsViewsPage = (0, _Loadable.default)({
  loader: function loader() {
    return import('./components/AnalyticsViewsPage'
    /* webpackChunkName: "chunk-analytics-and-tracking" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncAnalyticsViewsPage(props) {
  return _react.default.createElement(AnalyticsViewsPage, props);
}

var CookiePolicyPage = (0, _Loadable.default)({
  loader: function loader() {
    return import('./components/CookiePolicyPage'
    /* webpackChunkName: "chunk-analytics-and-tracking" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncCookiePolicyPage(props) {
  return _react.default.createElement(CookiePolicyPage, props);
}

var CustomJSPage = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/CustomJSContainer'
    /* webpackChunkName: "chunk-analytics-and-tracking" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncCustomJSPage(props) {
  return _react.default.createElement(CustomJSPage, props);
}